module.exports = __webpack_public_path__ + "media/customizations/mylwr/back-403774fa44a81e1c614d980ac8d389c5.jpg";